import { getFaal, getSharedFaalUrl } from "api/faal";
// import { useSnackbar } from 'notistack';
import { useMutation } from "react-query";

function useFaal() {
  // const { enqueueSnackbar } = useSnackbar();
  return useMutation(getFaal, {
    // onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onError: (err) => console.log(err.message, { variant: "error" }),
    onSuccess: () =>
      console.log("successfully divined", { variant: "success" }),
    // onSuccess: () => enqueueSnackbar('شما با موفقیت وارد پنل شدید.', { variant: 'success' }),
  });
}

function useSharedFaalUrl() {
  // const { enqueueSnackbar } = useSnackbar();
  return useMutation(getSharedFaalUrl, {
    // onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onError: (err) => console.log(err.message, { variant: "error" }),
    onSuccess: () =>
      console.log("successfully divined", { variant: "success" }),
    // onSuccess: () => enqueueSnackbar('شما با موفقیت وارد پنل شدید.', { variant: 'success' }),
  });
}

export { useFaal, useSharedFaalUrl };
